<template>
  <div class="switcher_header">
    <nav-bar></nav-bar>
    <transition>
      <div ref="drawerBody" class="drawer__body" v-show="pull_down">
        <div class="drawer-box">
          <router-link
              v-for="(tab, index) in tabs"
              :key="index"
              :to="tab.route"
          >
            {{ tab.name }}
          </router-link>
          </div>
        <div class="switcher__warp__after"><i class="iconfont general_pullup_s" @click="pull_down = !pull_down"></i></div>
      </div>
    </transition>
    <div class="switcher">
      <div class="switcher__container">
        <div class="switcher__warp">
          <ul class="switcher__tabs__list switcher__start">
            <router-link
                v-for="(tab, index) in tabs"
                :key="index"
                :to="{ path: tab.route, hash: tab.hash }"
                class="tabs__item"
                :class="{ 'active': isActiveTab(tab.route) }"
            >
              <span ref="tabSpans">{{ tab.name }}</span>
            </router-link>
            <div class="active-indicator" :style="indicatorStyle"/>
          </ul>
        </div>
        <div class="switcher__warp__after"><i class="iconfont general_pulldown_s" @click="pull_down = !pull_down"></i></div>
      </div>
    </div>
  </div>
  <div style="height: 24vw"></div>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<script>
import NavBar from "@/components/common/NavBar";
import {useModalStore} from "@/store/pinia";
export default {
  name: "HomePage",
  data() {
    return {
      tabs: [
        { name: "首页", route: "/", hash: '#index'},
        {name: "福利姬", route: "/v/fuliji", hash: '#fuliji'},
        {name: "ASMR", route: "/v/asmr", hash: '#asmr'},
        { name: "国播", route: "/v/zb", hash: '#zb'},
        { name: "韩播", route: "/v/hgzb", hash: '#hgzb'},
        { name: "麻豆", route: "/v/md", hash: '#md'},
        { name: "国创", route: "/v/gc", hash: '#gc'},//----
        {name: "大象传媒", route: "/v/dxcm", hash: '#gc'},//----
        {name: "91大神", route: "/v/91ds", hash: '#91ds'},
        {name: "颜值区", route: "/v/kjmt", hash: '#kjmt'},
        { name: "网爆门", route: "/v/wbm", hash: '#wbm'},
        { name: "精品视频", route: "/v/jpsp", hash: '#jpsp'},
        { name: "探花", route: "/v/th", hash: '#th'}, //----
        { name: "户外", route: "/v/hw", hash: '#hw'},
        { name: "女学生", route: "/v/nxs", hash: '#nxs'},
        { name: "职场", route: "/v/zc", hash: '#zc'},
        { name: "国产伦理", route: "/v/gcll", hash: '#gcll'},
        { name: "空姐模特", route: "/v/kjmt", hash: '#kjmt'},
        { name: "美少妇", route: "/v/msf", hash: '#msf'},
        { name: "中字", route: "/v/zz", hash: '#zz'},
        { name: "步兵", route: "/v/wm", hash: '#wm'},
        { name: "巨乳", route: "/v/jr", hash: '#jr'}, //----
        { name: "制服", route: "/v/zf", hash: '#zf'}, //----
        { name: "丝袜", route: "/v/sw", hash: '#sw'}, //----
        { name: "强制", route: "/v/qj", hash: '#qj'}, //----
        { name: "调教", route: "/v/tj", hash: '#tj'}, //----
        { name: "出轨", route: "/v/cg", hash: '#cg'}, //----
        { name: "伦理", route: "/v/ll", hash: '#ll'}, //----
        { name: "人妻", route: "/v/rq", hash: '#rq'}, //----
        { name: "骑兵", route: "/v/qb", hash: '#qb'}, //----
        { name: "动漫", route: "/v/kt", hash: '#kt'}, //----
        {name: "AV解说", route: "/v/avjs", hash: '#avjs'},
        { name: "欧美", route: "/v/eu", hash: '#eu'}, //----
        { name: "AI换脸", route: "/v/ai", hash: '#ai'}, //----
      ],
      pull_down:false,
      modalStore:useModalStore(),
    };
  },
  components: {
    NavBar,
  },
  computed: {
    indicatorStyle() {
      const activeTabIndex = this.tabs.findIndex(tab => this.isActiveTab(tab.route));
      return this.modalStore.homeIndicatorStyle[activeTabIndex];
    },
  },
  methods: {
    isActiveTab(route) {
      return this.$route.path === route;
    },
    initIndicatorStyle(){
      let spans = this.$refs.tabSpans;
      if (!Array.isArray(spans)) {
        spans = [spans];
      }
      const paddingREM = 1.2;
      const tabs = Array.from(document.querySelectorAll('.tabs__item'));
      const actualFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      let totalWidthBefore = 0;
      for (let i = 0; i < tabs.length; i++) {
        const activeSpanWidth = spans[i]?.getBoundingClientRect().width;
        const style = {
          transform: `translateX(${(totalWidthBefore+paddingREM*actualFontSize)}px)`,
          width: `${activeSpanWidth}px`
        }
        this.modalStore.setHomeIndicatorStyle(i, style)
        totalWidthBefore += tabs[i].getBoundingClientRect().width;
      }
    }
  },
  watch:{
    pull_down(newVal) {
      const drawerBody = this.$refs.drawerBody;
      if (newVal) {
        drawerBody.style.transform = "translateY(0)";
      } else {
        drawerBody.style.transform = "translateY(-100%)";
      }
    },
  },
  mounted() {
    this.initIndicatorStyle()
  }
}
</script>

<style scoped lang="scss">
html {
  font-size: calc(16px + 0.1vw); /* 基于屏幕宽度微调 */
}

.drawer__body {
  position: fixed;
  top: 13.056vw;
  left: 0;
  right: 0;
  padding: 2.66667vmin 5.33333vmin 0.33333vmin;
  background-color: #fff;
  color: #757575;
  font-size: 3.73333vw;
  z-index: 999;
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .drawer-box{
    display: flex;
    flex-wrap: wrap;
    color: #757575;
    font-size: 3.73333vmin;
    a{
      margin: 2.13333vmin;
      white-space: nowrap;
      text-decoration: none;
      color: #757575;
    }
  }
  .general_pullup_s{
    margin: 0 2.66667vmin;
    color: #aaa;
    font-size: 5.33333vmin;
  }
}
.switcher {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top:13.056vw;
  z-index: 10;
  .switcher__container {
    height: 10.66667vmin;
    position: relative;
    display: flex;
    align-items: center;
    background-color: #fff;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #e7e7e7;
      transform: scaleY(0.5);
    }

    .switcher__warp {
      overflow-x: auto; /* Enable horizontal scrolling */
      overflow-y: hidden; /* Disable vertical scrolling */
      height: 100%;
      flex: 1;
      -webkit-font-smoothing: antialiased; /* 改善字体渲染 */
      text-rendering: geometricPrecision;
      scrollbar-width: none; /* For Firefox */
      -ms-overflow-style: none; /* For Internet Explorer and Edge */
    }
    .switcher__warp::-webkit-scrollbar {
      display: none; /* For Chrome, Safari, and Opera */
    }
  }
  .switcher__warp__after{
    float: right;
    order: 3;
    position: relative;
    flex-shrink: 0;
    z-index: 1;
    .general_pulldown_s{
      margin: 0 2.66667vmin;
      color: #aaa;
      font-size: 5.33333vmin;
    }
  }
}

.tabs__item {
  height: 10.66667vmin;
  line-height: 10.66667vmin;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  user-select: none;
  font-size: 1rem;
  padding: 0 1.2rem;
  color: #505050;
}

.switcher__tabs__list {
  position: relative;
  z-index: 1;
  padding: 0;
  margin: 0;
  display: flex;
  white-space: nowrap;

  .active-indicator {
    position: absolute;
    bottom: 0;
    height: 0.53333vmin;
    border-radius: 0.53333vmin;
    background: #fb7a9f;
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    pointer-events: none;
  }
}

.active {
  color: #fb7a9f !important; /* 选中时的主题颜色 */
  font-weight: normal !important; /* 移除加粗 */
}
</style>

